<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Dashboards</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">Welcome to GEMS UPresence</p>
              </div>
              <div class="col-12 col-md-auto">
                <!-- <button
                  class="btn btn-primary lift"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  <span class="fe fe-folder-plus"></span>
                  Report
                </button> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid d-none">
      <div class="row d-none">
        <div class="col-12 col-lg-6 col-xl">
          <!-- Value  -->
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center gx-0">
                <div class="col">
                  <!-- Title -->
                  <h6 class="text-uppercase text-muted mb-2">Value</h6>

                  <!-- Heading -->
                  <span class="h2 mb-0"> $24,500 </span>

                  <!-- Badge -->
                  <span class="badge bg-success-soft mt-n1"> +3.5% </span>
                </div>
                <div class="col-auto">
                  <!-- Icon -->
                  <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                </div>
              </div>
              <!-- / .row -->
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl">
          <!-- Hours -->
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center gx-0">
                <div class="col">
                  <!-- Title -->
                  <h6 class="text-uppercase text-muted mb-2">Total hours</h6>

                  <!-- Heading -->
                  <span class="h2 mb-0"> 763.5 </span>
                </div>
                <div class="col-auto">
                  <!-- Icon -->
                  <span class="h2 fe fe-briefcase text-muted mb-0"></span>
                </div>
              </div>
              <!-- / .row -->
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl">
          <!-- Exit -->
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center gx-0">
                <div class="col">
                  <!-- Title -->
                  <h6 class="text-uppercase text-muted mb-2">Exit %</h6>

                  <!-- Heading -->
                  <span class="h2 mb-0"> 35.5% </span>
                </div>
                <div class="col-auto">
                  <!-- Chart -->
                  <div class="chart chart-sparkline">
                    <canvas class="chart-canvas" id="sparklineChart"></canvas>
                  </div>
                </div>
              </div>
              <!-- / .row -->
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl">
          <!-- Time -->
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center gx-0">
                <div class="col">
                  <!-- Title -->
                  <h6 class="text-uppercase text-muted mb-2">Avg. Time</h6>

                  <!-- Heading -->
                  <span class="h2 mb-0"> 2:37 </span>
                </div>
                <div class="col-auto">
                  <!-- Icon -->
                  <span class="h2 fe fe-clock text-muted mb-0"></span>
                </div>
              </div>
              <!-- / .row -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="card">
            <div class="card-header">User Activity</div>
            <div class="card-body">
              <l-map
                style="height: 500px"
                :zoom="zoom"
                :center="center"
                class="map-index"
              >
                <l-tile-layer
                  :url="url"
                  :attribution="attribution"
                ></l-tile-layer>
                <l-marker
                  :lat-lng="markerLatLng"
                  :icon="icon"
                  @click="(e) => viewProfile(e)"
                ></l-marker>
              </l-map>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="card">
            <div class="card-header">User Access Location</div>
            <div class="card-body"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- Goals -->
          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">
                  <!-- Title -->
                  <h4 class="card-header-title">Goals</h4>
                </div>
                <div class="col-auto">
                  <!-- Button -->
                  <a href="#!" class="btn btn-sm btn-white"> Export </a>
                </div>
              </div>
              <!-- / .row -->
            </div>
            <div
              class="table-responsive mb-0"
              data-list='{"valueNames": ["goal-project", "goal-status", "goal-progress", "goal-date"]}'
            >
              <table class="table table-sm table-nowrap card-table">
                <thead>
                  <tr>
                    <th>
                      <a
                        href="#"
                        class="text-muted list-sort"
                        data-sort="goal-project"
                      >
                        Goal
                      </a>
                    </th>
                    <th>
                      <a
                        href="#"
                        class="text-muted list-sort"
                        data-sort="goal-status"
                      >
                        Status
                      </a>
                    </th>
                    <th>
                      <a
                        href="#"
                        class="text-muted list-sort"
                        data-sort="goal-progress"
                      >
                        Progress
                      </a>
                    </th>
                    <th>
                      <a
                        href="#"
                        class="text-muted list-sort"
                        data-sort="goal-date"
                      >
                        Due date
                      </a>
                    </th>
                    <th class="text-end">Team</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr>
                    <td class="goal-project">Update the API</td>
                    <td class="goal-status">
                      <span class="text-warning">●</span> In progress
                    </td>
                    <td class="goal-progress">55%</td>
                    <td class="goal-date">
                      <time datetime="2018-10-24">07/24/18</time>
                    </td>
                    <td class="text-end">
                      <div class="avatar-group">
                        <a
                          href="profile-posts.html"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Dianna Smiley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-1.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="profile-posts.html"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Ab Hadley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-2.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="profile-posts.html"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Adolfo Hess"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-3.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="profile-posts.html"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Daniela Dewitt"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-4.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                      </div>
                    </td>
                    <td class="text-end">
                      <div class="dropdown">
                        <a
                          href="#"
                          class="dropdown-ellipses dropdown-toggle"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="fe fe-more-vertical"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="#!" class="dropdown-item"> Action </a>
                          <a href="#!" class="dropdown-item">
                            Another action
                          </a>
                          <a href="#!" class="dropdown-item">
                            Something else here
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="goal-project">Release v1.2-Beta</td>
                    <td class="goal-status">
                      <span class="text-warning">●</span> In progress
                    </td>
                    <td class="goal-progress">25%</td>
                    <td class="goal-date">
                      <time datetime="2018-10-24">08/26/18</time>
                    </td>
                    <td class="text-end">
                      <div class="avatar-group justify-content-end">
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Dianna Smiley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-1.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Ab Hadley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-2.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Adolfo Hess"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-3.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                      </div>
                    </td>
                    <td class="text-end">
                      <div class="dropdown">
                        <a
                          href="#"
                          class="dropdown-ellipses dropdown-toggle"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="fe fe-more-vertical"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="#!" class="dropdown-item"> Action </a>
                          <a href="#!" class="dropdown-item">
                            Another action
                          </a>
                          <a href="#!" class="dropdown-item">
                            Something else here
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="goal-project">GDPR Compliance</td>
                    <td class="goal-status">
                      <span class="text-success">●</span> Completed
                    </td>
                    <td class="goal-progress">100%</td>
                    <td class="goal-date">
                      <time datetime="2018-10-24">06/19/18</time>
                    </td>
                    <td class="text-end">
                      <div class="avatar-group justify-content-end">
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Dianna Smiley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-1.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Ab Hadley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-2.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Adolfo Hess"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-3.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                      </div>
                    </td>
                    <td class="text-end">
                      <div class="dropdown">
                        <a
                          href="#"
                          class="dropdown-ellipses dropdown-toggle"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="fe fe-more-vertical"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="#!" class="dropdown-item"> Action </a>
                          <a href="#!" class="dropdown-item">
                            Another action
                          </a>
                          <a href="#!" class="dropdown-item">
                            Something else here
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="goal-project">v1.2 Documentation</td>
                    <td class="goal-status">
                      <span class="text-danger">●</span> Cancelled
                    </td>
                    <td class="goal-progress">0%</td>
                    <td class="goal-date">
                      <time datetime="2018-10-24">06/25/18</time>
                    </td>
                    <td class="text-end">
                      <div class="avatar-group justify-content-end">
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Dianna Smiley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-1.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Ab Hadley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-2.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                      </div>
                    </td>
                    <td class="text-end">
                      <div class="dropdown">
                        <a
                          href="#"
                          class="dropdown-ellipses dropdown-toggle"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="fe fe-more-vertical"></span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="#!" class="dropdown-item"> Action </a>
                          <a href="#!" class="dropdown-item">
                            Another action
                          </a>
                          <a href="#!" class="dropdown-item">
                            Something else here
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="goal-project">Plan design offsite</td>
                    <td class="goal-status">
                      <span class="text-success">●</span> Completed
                    </td>
                    <td class="goal-progress">100%</td>
                    <td class="goal-date">
                      <time datetime="2018-10-24">06/30/18</time>
                    </td>
                    <td class="text-end">
                      <div class="avatar-group justify-content-end">
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Dianna Smiley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-1.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Ab Hadley"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-2.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Adolfo Hess"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-3.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                        <a
                          href="#!"
                          class="avatar avatar-xs"
                          data-bs-toggle="tooltip"
                          title="Daniela Dewitt"
                        >
                          <img
                            src="../../assets/img/avatars/profiles/avatar-4.jpg"
                            class="avatar-img rounded-circle"
                            alt="..."
                          />
                        </a>
                      </div>
                    </td>
                    <td class="text-end">
                      <div class="dropdown">
                        <a
                          href="#"
                          class="dropdown-ellipses dropdown-toggle"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="fe fe-more-vertical"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="#!" class="dropdown-item"> Action </a>
                          <a href="#!" class="dropdown-item">
                            Another action
                          </a>
                          <a href="#!" class="dropdown-item">
                            Something else here
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import { icon } from "leaflet";
// import Chart from 'chart.js'
export default {
  name: "awokComponent",
  data() {
    return {
      direct: false,
      comp: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 9,
      center: [-3.494230910434892, 475.6338500976563],
      markerLatLng: [-3.494230910434892, 475.6338500976563],
      icon: icon({
        iconUrl: "/img/marker.png",
        iconSize: [20, 30],
        iconAnchor: [16, 29],
      }),
    };
  },
  mounted() {
    // this.getAllPointing();
  },
  methods: {
    viewProfile() {
      alert("test");
    },
    getAllPointing() {
      this.$store.dispatch("location/GET_LOCATION_ACTIVITY");
    },
  },
};
</script>
